export default {
  setCampaignResults(state, value) {
    state.campaignResults = value;
  },

  setCampaignResultsLoaded(state, value) {
    state.campaignResultsLoaded = value;
  },
};
